import { uniqBy } from 'lodash-es';
import {
  BaseRouteProjectionType,
  LogisticsResourceType,
  ResponseRouteLegTypeEnum,
  RouteLegTypeEnum,
  SupplementalLiftAviaLegResponse,
  TxCenterProviderAviaLegResponse,
} from '@/api/apis/route';
import { CaseResourceType } from '@/api/apis/case';

const PROVIDER_AVIA_LEG_TYPES = [
  ResponseRouteLegTypeEnum.SupplementalLiftAviaLeg,
  ResponseRouteLegTypeEnum.TxCenterProviderAviaLeg,
];

export type PilotInfo = {
  firstName: string;
  lastName: string;
  phone: string;
  type: ResponseRouteLegTypeEnum;
};

export const getRoutePilots = (logisticsResources?: LogisticsResourceType[], mainRoute?: BaseRouteProjectionType) => {
  if (!logisticsResources?.length && !mainRoute) return [];

  const tmdxPilots = logisticsResources
    ?.filter((r) => r.resourceType === CaseResourceType.Crew)
    .map((r) => ({
      firstName: r.firstName || '',
      lastName: r.lastName || '',
      phone: r.phoneNumber || '',
      type: ResponseRouteLegTypeEnum.TmdxJetAviaLeg,
    }));

  const providerAviaLegs =
    mainRoute?.legs.filter((l): l is SupplementalLiftAviaLegResponse | TxCenterProviderAviaLegResponse =>
      PROVIDER_AVIA_LEG_TYPES.includes(l.$type),
    ) || [];
  const providerPilots = providerAviaLegs.flatMap((l) => [
    ...(l.firstCrewMember.phoneNumber
      ? [
          {
            firstName: l.firstCrewMember.firstName || '',
            lastName: l.firstCrewMember.lastName || '',
            phone: l.firstCrewMember.phoneNumber || '',
            type: l.$type,
          },
        ]
      : []),
    ...(l.secondCrewMember.phoneNumber
      ? [
          {
            firstName: l.secondCrewMember.firstName || '',
            lastName: l.secondCrewMember.lastName || '',
            phone: l.secondCrewMember.phoneNumber || '',
            type: l.$type,
          },
        ]
      : []),
  ]);

  const pilots = [...(tmdxPilots || []), ...providerPilots];

  return uniqBy(pilots, 'phone');
};

export const getLegCrewTitle = (legType: RouteLegTypeEnum | ResponseRouteLegTypeEnum) => {
  switch (legType) {
    case RouteLegTypeEnum.TmdxJetAviaLeg:
    case ResponseRouteLegTypeEnum.TmdxJetAviaLeg:
      return 'TMDX Pilot';
    case RouteLegTypeEnum.SupplementalLiftAviaLeg:
    case ResponseRouteLegTypeEnum.SupplementalLiftAviaLeg:
      return 'Supplemental Lift Provider Pilot';
    case RouteLegTypeEnum.TxCenterProviderAviaLeg:
    case ResponseRouteLegTypeEnum.TxCenterProviderAviaLeg:
      return 'TX Partner Pilot';
    case ResponseRouteLegTypeEnum.TmdxAffiliateGroundLeg:
    case RouteLegTypeEnum.TmdxAffiliateGroundLeg:
    case ResponseRouteLegTypeEnum.TmdxDriveAffiliateGroundLeg:
    case RouteLegTypeEnum.TmdxDriveAffiliateGroundLeg:
      return 'TMDX Affiliate Driver';
    case ResponseRouteLegTypeEnum.TxCenterProviderGroundLeg:
    case RouteLegTypeEnum.TxCenterProviderGroundLeg:
      return 'TX Center Driver';
    case ResponseRouteLegTypeEnum.TmdxDriveTedsGroundLeg:
    case RouteLegTypeEnum.TmdxDriveTedsGroundLeg:
      return 'TEDS Driver';
    default:
      return '';
  }
};
